module.exports = __webpack_public_path__ + "img/756.fa91d9c8.png";